import {UserMarketingRules} from "@app/core/user-marketing-rules/domain/user-marketing-rules";
import {Observable} from "rxjs";

export abstract class UserMarketingRulesRepository {
    abstract search(): Observable<UserMarketingRules | null>;
    abstract update(userData: UserMarketingRules): Observable<void>;
}